import { render } from "./Licensing.vue?vue&type=template&id=779e0b06&scoped=true"
import script from "./Licensing.vue?vue&type=script&lang=js"
export * from "./Licensing.vue?vue&type=script&lang=js"

import "./Licensing.vue?vue&type=style&index=0&id=779e0b06&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779e0b06"]])

export default __exports__